<template>
	<div v-if="addresses" class="properties">
		<a class="property-card" v-for="obj in addresses" :key="obj.property_id" :href="`property/${obj.property_id}#Property_Summary`">
			<div class="info">
				<div class="header3 value">{{ obj.address.toLowerCase() }}</div>
				<div class="header4 label">PIN: {{ obj.pin }}</div>
			</div>
			<img src="/svg/gray_right_arrow.svg" class="il-background" />
		</a>
		<div v-if="addresses.length == 0">No result</div>
	</div>
</template>

<script>
export default {
	name: "properties",
	props: {
		search: String,
		addresses: Array,
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.properties {
	max-width: 1100px;
	margin: auto;
	margin-top: 65px;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(540px, 1fr));
	grid-gap: 20px;
	padding: 0 25px;
}
@media screen and (max-width: 580px) {
	.properties {
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	}
}
a {
	text-decoration: none;
}
.property-card {
	border: 1px solid #dbdee7;
	border-radius: 6px;
	height: 130px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0 25px;
	.label {
		padding-top: 7px;
		text-align: left;
		font-weight: 500;
		color: var(--accent);
	}
	.value {
		text-align: left;
		font-weight: 500;
		color: #4d4d4d;
		text-transform: capitalize;
	}
}
.property-card:hover {
	cursor: pointer;
	box-shadow: 6px 5px 12px rgba(94, 222, 222, 0.3);
}
</style>
